module.exports = __webpack_public_path__ + "static/media/preview_white.12e884bc.png";